import { Select } from 'antd';
import FormItem from 'components/form/FormItem';
import { useRestContext } from 'components/form/RestInputContext';
import _, { map } from 'lodash';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DynamicObjectType } from 'types/commons';
import { getRecordData } from 'utils/tools';

const { Option } = Select;

interface SelectCustomTypes {
  disabled?: boolean;
  placeholder?: string;
  header?: string;
  required?: boolean;
  source: string;
  resourceData: DynamicObjectType[];
  valueProp?: string;
  titleProp?: string;
  allowClear?: boolean;
  formOptions?: DynamicObjectType;
  onChange?: (e: any) => void;
}

export default function SelectCustom({
  disabled,
  placeholder,
  header,
  required,
  source,
  resourceData,
  valueProp = 'id',
  titleProp = 'name',
  allowClear,
  formOptions,
  ...props
}: SelectCustomTypes) {
  const { t } = useTranslation();

  const { record } = useRestContext();
  const defaultValue = getRecordData(record, source);

  const [options, setOptions] = useState([]);

  const onSearch = (value: string) => {
    if (value) {
      const filter = _.filter(resourceData, (val) =>
        _.includes(
          _.toLower(_.deburr(val[titleProp])),
          _.toLower(_.deburr(value)),
        ),
      );
      setOptions(filter);
    } else {
      setOptions(resourceData);
    }
  };

  useEffect(() => {
    setOptions(resourceData);
  }, [resourceData]);

  return (
    <FormItem
      ruleType={Array.isArray(defaultValue) ? 'array' : 'string'}
      formOptions={formOptions}
      disbaled={disabled}
      placeholder={placeholder}
      label={header}
      required={required}
      initialValue={
        defaultValue?.map?.((e) => e?.id || e) ||
        defaultValue?.id ||
        defaultValue
      }
      name={source}
    >
      <Select
        allowClear={allowClear}
        showSearch
        optionFilterProp={valueProp}
        placeholder={placeholder}
        onSearch={onSearch}
        filterOption={() => true}
        onChange={props.onChange}
      >
        {map(options, (data) => (
          <Option
            key={getRecordData(data, valueProp)}
            value={getRecordData(data, valueProp)}
          >
            {getRecordData(data, titleProp) &&
              t(getRecordData(data, titleProp))}
          </Option>
        ))}
      </Select>
    </FormItem>
  );
}
